// extracted by mini-css-extract-plugin
export default {"wrap":"ProductGroupComponent_wrap__f2dGu","title":"ProductGroupComponent_title__nB+sf","blockButton":"ProductGroupComponent_blockButton__jvcK0"};